/* eslint-disable */
import { useState, useEffect, useContext, useMemo, useRef } from "react";

// material react table
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { Link } from "react-router-dom";

const FIELD_TO_PARAM = {
  name: "name",
  unitsperday: "unitsperday",
  materialkitdate: "materialkitdate",
};

const MaterialKitList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const {
    reloadMaterialList,
    setReloadMaterialList,
    setEditMaterialData,
    screenHeight,
  } = useContext(GlobalProvider);

  // default user data ------------------------------------
  const [materialData, setMaterialData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return materialData.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : materialData;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Material Kit.xlsx");
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name}</span>

          {/* ------ edit icon start ------ */}
          <Link
            to="#saveMaterialPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditMaterialData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
          {/* ------ edit icon end ------ */}

          {/* -------------- calendar icon start ------------- */}
          <Link
            to={"/materialcalendar/" + dataItem._id}
            className="icon-btn edit_icon"
            role="button"
          >
            <span className="d-block material-symbols-outlined">
              calendar_month
            </span>
          </Link>
          {/* -------------- calendar icon end ------------- */}
        </div>
      </div>
    );
  };

  //function for get all data
  const getAllData = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_MATERIAL_KIT + `?token=${token}`;

      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      const response = await getData(requestUrl);

      console.log(`Material kit response`, response);
      if (response.status) {
        setMaterialData(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (reloadMaterialList) {
      getAllData();
      setReloadMaterialList(false);
    }
  }, [reloadMaterialList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllData();
    }
  }, [responseReceived]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records when materialData changes */
  useEffect(() => {
    setRecords(materialData.length);
  }, [materialData]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllData(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, materialData]);

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        Cell: ({ row }) => nameHTML({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "unitsperday",
        accessorKey: "unitsperday",
        header: t("Unit Available Per Day"),
        size: 200,
      },
      {
        id: "materialkitdate",
        accessorKey: "materialkitdate",
        header: t("Date"),
        size: 200,
      },
    ],
    [materialData]
  );

  return (
    <div className="activity_table">
      <div className="table-responsive">
        <MaterialReactTable
          columns={tableColumns}
          data={materialData}
          enableSorting
          enableFilters
          enableGlobalFilter={false}
          manualFiltering
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          onColumnFiltersChange={setColumnFilters}
          getRowId={(row) => row._id}
          state={{ rowSelection, columnFilters }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
      </div>
    </div>
  );
};

export default MaterialKitList;
